import { Intro as NatDsIntro } from '@naturacosmeticos/natds-web/dist/Components/Intro'

export const Intro = NatDsIntro
